import React from "react";
import TopToolbar from "../../global/subcomponents/topToolbar/TopToolbar";
import {
    BALANCE_SHEET, BALANCE_SHEET_PAGES,
    BALANCE_SHEET_SUMMARY_FIELDS,
    SETTINGS,
} from './constants';
import { Layout } from "../../global/Table/TablePageHelpers/LayoutObject";
import { TableCell, Select, MenuItem, FormControl, InputLabel, Box } from "@mui/material";
import TablePage from "../../global/Table/TablePage";
import '../shippingSummary/ShippingSummary.css';
import SettingsIcon from "@material-ui/icons/Settings";
import {HourglassEmptyTwoTone} from "@material-ui/icons";
import RefreshIcon from '@material-ui/icons/Refresh';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import * as XLSX from 'xlsx';

class BalanceSheetTable extends React.Component {
    constructor(props) {
        super(props)
    }

    getTableHeaders = () => {
        let headers = [];

       BALANCE_SHEET_SUMMARY_FIELDS.forEach((headCell, index) => {
            if (index === 0) {
                headers.push(Layout.columnHead(headCell.label, headCell.null, "left")); // Adjust alignment to left for index 0
            } else {
                headers.push(Layout.columnHead(headCell.label, headCell.null, "center")); // Default alignment for other headers
            }
        });
        return headers;
    }

    tableRowAssets = (summary, index) => {
        if (summary) {
            const lastIndex = this.props.assetsList.length - 1;
            return (
                <React.Fragment>

                    <TableCell
                        className="table-tax-cell-left"
                        style={{
                            width: '30%',
                            fontWeight: summary.name === "Total Assets" ||
                            summary.name === "CURRENT ASSETS" ||
                            summary.name === "Difference" ? 'bold' : 'normal',
                            borderBottom: index === lastIndex ? 'none' : '1px solid #ddd',
                        }}
                    >
                        {summary?.name}
                    </TableCell>



                    {summary?.amount ? (
                        summary?.amount !== 0 ? (
                        <TableCell
                            className="table-tax-cell-left"
                            style={{
                                width: '10%',
                                borderBottom: index === lastIndex ? 'none' : '1px solid #ddd',
                            }}
                        >
                            <div
                                style={{
                                  fontWeight: summary.name === "Total Assets" ||
                                  summary.name === "CURRENT ASSETS" ||
                                  summary.name === "Difference" ? 'bold' : 'normal',
                                    display: 'flex',
                                    justifyContent: 'flex-end',
                                    alignItems: 'center',
                                    gap: '3px',
                                    marginRight: '15px',
                                }}
                            >
                                <span style={{ flexShrink: 0, marginRight: 'auto' }}>$</span>
                                <span style={{ marginLeft: 0 }}>
                                {parseFloat(summary?.amount)
                                    .toFixed(2)
                                    .toString()
                                    .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')}
                            </span>
                            </div>
                        </TableCell>
                        ) : (
                            <TableCell
                                className="table-tax-cell-left"
                                style={{
                                    width: '10%',
                                    borderBottom: index === lastIndex ? 'none' : '1px solid #ddd',
                                }}
                            />
                        )
                    ) : <TableCell
                        className="table-tax-cell-left"
                        style={{
                            width: '10%',
                            borderBottom: index === lastIndex ? 'none' : '1px solid #ddd',
                        }}
                    >
                        <div
                            style={{
                              fontWeight: summary.name === "Total Assets" ||
                              summary.name === "CURRENT ASSETS" ||
                              summary.name === "Difference" ? 'bold' : 'normal',
                                display: 'flex',
                                justifyContent: 'flex-end',
                                alignItems: 'center',
                                gap: '3px',
                                marginRight: '15px',
                            }}
                        >
                            <span style={{flexShrink: 0, marginRight: 'auto'}}></span>
                            <span style={{marginLeft: 0}}>&nbsp;</span>
                        </div>
                    </TableCell>
                    }

                </React.Fragment>
            );
        }
        return null;
    };

    tableRowLiabilityAndEquity = (summary, index) => {
        if (summary) {
            const lastIndex = this.props.liabilityAndEquityList.length - 1;
            return (
              <React.Fragment>
                <TableCell
                  className="table-tax-cell-left"
                  style={{
                    width: '30%',
                      borderLeft: '1px solid rgba(224, 224, 224, 1)',
                    fontWeight: summary.name === "Total Equity" ||
                    summary.name === "Total Liabilities" ||
                    summary.name === "Total Equity and Liabilities" ||
                    summary.name === "CURRENT LIABILITIES" ||
                    summary.name === "OWNER'S EQUITY" ||
                    summary.name === "Difference" ? 'bold' : 'normal',
                    borderBottom: index === lastIndex ? 'none' : '1px solid #ddd',
                  }}
                >
                  {summary?.name}
                </TableCell>



                {summary?.amount ? (
                  summary?.amount !== 0 ? (
                    <TableCell
                      className="table-tax-cell-left"
                      style={{
                        width: '10%',
                        borderBottom: index === lastIndex ? 'none' : '1px solid #ddd',
                      }}
                    >
                      <div
                        style={{
                          fontWeight: summary.name === "Total Equity" ||
                          summary.name === "Total Liabilities" ||
                          summary.name === "Total Equity and Liabilities" ||
                          summary.name === "CURRENT LIABILITIES" ||
                          summary.name === "OWNER'S EQUITY" ||
                          summary.name === "Difference" ? 'bold' : 'normal',
                          display: 'flex',
                          justifyContent: 'flex-end',
                          alignItems: 'center',
                          gap: '3px',
                          marginRight: '15px',
                        }}
                      >
                        <span style={{ flexShrink: 0, marginRight: 'auto' }}>$</span>
                        <span style={{ marginLeft: 0 }}>
                                {parseFloat(summary?.amount)
                                  .toFixed(2)
                                  .toString()
                                  .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')}
                            </span>
                      </div>
                    </TableCell>
                  ) : (
                    <TableCell
                      className="table-tax-cell-left"
                      style={{
                        width: '10%',
                        borderBottom: index === lastIndex ? 'none' : '1px solid #ddd',
                      }}
                    />
                  )
                ) : <TableCell
                  className="table-tax-cell-left"
                  style={{
                    width: '10%',
                    borderBottom: index === lastIndex ? 'none' : '1px solid #ddd',
                  }}
                >
                  <div
                    style={{
                      fontWeight: summary.name === "Total Equity" ||
                      summary.name === "Total Liabilities" ||
                      summary.name === "Total Equity and Liabilities" ||
                      summary.name === "CURRENT LIABILITIES" ||
                      summary.name === "OWNER'S EQUITY" ||
                      summary.name === "Difference" ? 'bold' : 'normal',
                      display: 'flex',
                      justifyContent: 'flex-end',
                      alignItems: 'center',
                      gap: '3px',
                      marginRight: '15px',
                    }}
                  >
                    <span style={{flexShrink: 0, marginRight: 'auto'}}></span>
                    <span style={{marginLeft: 0}}>&nbsp;</span>
                  </div>
                </TableCell>
                }

              </React.Fragment>
            );
        }
        return null;
    };

    searchStrings = (summary) => {
        return [summary.name]
    }

  handleExport = () => {
    const { assetsList, liabilityAndEquityList, selectedYear, selectedCurrency } = this.props;

    const maxLength = Math.max(assetsList.length, liabilityAndEquityList.length);

    const rows = [
      ['Exponet Canada Inc.'],
      [`Balance Sheet as of December 31, ${selectedYear}`],
      ['', '', '', '', ''],
    ];

    for (let i = 0; i < maxLength; i++) {
      const asset = assetsList[i] || { name: '', amount: '' };
      const liability = liabilityAndEquityList[i] || { name: '', amount: '' };

      rows.push([
        asset.name || '',
        asset.amount && asset.amount !== 0 ? parseFloat(asset.amount) : '',
        '',
        liability.name || '',
        liability.amount && liability.amount !== 0 ? parseFloat(liability.amount) : ''
      ]);
    }

    const ws = XLSX.utils.aoa_to_sheet(rows);

    ws['!merges'] = [
      { s: { r: 0, c: 0 }, e: { r: 0, c: 4 } },
      { s: { r: 1, c: 0 }, e: { r: 1, c: 4 } },
    ];

    const createCellIfNotExists = (ws, cell) => {
      if (!ws[cell]) {
        ws[cell] = { v: '' };
      }
    };

    const range1 = ['A1', 'B1', 'C1', 'D1', 'E1'];
    range1.forEach(cell => {
      createCellIfNotExists(ws, cell);
      ws[cell].s = { alignment: { horizontal: 'center', vertical: 'center' } };
    });

    const range2 = ['A2', 'B2', 'C2', 'D2', 'E2'];
    range2.forEach(cell => {
      createCellIfNotExists(ws, cell);
      ws[cell].s = { alignment: { horizontal: 'center', vertical: 'center' } };
    });

    // Ensure columns B and E (1 and 4) have numeric cell types
    for (let rowIndex = 3; rowIndex < rows.length; rowIndex++) {
      const bCellAddress = XLSX.utils.encode_cell({ r: rowIndex, c: 1 });
      const eCellAddress = XLSX.utils.encode_cell({ r: rowIndex, c: 4 });

      const bCell = ws[bCellAddress];
      const eCell = ws[eCellAddress];

      if (bCell && typeof bCell.v === 'number') {
        bCell.t = 'n'; // number
        bCell.z = '0.00'; // optional: 2 decimal places
      }

      if (eCell && typeof eCell.v === 'number') {
        eCell.t = 'n';
        eCell.z = '0.00';
      }
    }

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Balance Sheet');
    XLSX.writeFile(wb, `Balance_Sheet_${selectedYear}_${selectedCurrency}.xlsx`);
  };

  getContextualMenuItems = () => {
        let menuItems = []
        menuItems.push(
            {
                title: SETTINGS,
                icon: <SettingsIcon/>,
                onClick: () => this.props.setCurrentPage(BALANCE_SHEET_PAGES.SETTINGS, {})
            })
      menuItems.push(
          {
            title: 'Download as CSV',
            icon: <FileDownloadIcon />,
            onClick: () => {
              this.handleExport()
            }
          }
        )
        if (this.props.loadingData) {
            menuItems.push({
                icon: <HourglassEmptyTwoTone />,
                handler: () => null,
                disabled: true,
                title: "Loading data..."
            });
        }

        return menuItems
    }

    render() {

        const currentYear = new Date().getFullYear();
        const startYear = 2023;
        const years = Array.from(
          { length: currentYear - startYear + 1 },
          (_, i) => (startYear + i).toString()
        );

        const currency = ['CAD', 'USD', 'Consolidated CAD']
        const {  selectedYear, selectedCurrency, handleCurrencyChange, handleYearChange } = this.props

        return (
            <React.Fragment>
                <TopToolbar
                    pageName={BALANCE_SHEET}
                    menuItems={this.getContextualMenuItems()}
                />


                <Box className="box-balance-sheet">


                    <FormControl variant="outlined" className="form-control">
                        <InputLabel id="year-label">Year</InputLabel>
                        <Select
                            className="select-year"
                            labelId="year-label"
                            value={selectedYear}
                            onChange={handleYearChange}
                            label="Year"
                        >
                            {years.map((year) => (
                                <MenuItem key={year} value={year}>
                                    {year}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>


                    <FormControl variant="outlined" className="form-control">
                        <InputLabel id="currency-label">Currency</InputLabel>
                        <Select
                            style={{width:'200px', height:'48px',marginLeft:'-4px'}}
                            labelId="currency-label"
                            value={selectedCurrency}
                            onChange={handleCurrencyChange}
                            label="Currency"
                        >
                            {currency.map((currency) => (
                                <MenuItem key={currency} value={currency}>
                                    {currency}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Box>

                <div className="rowSpecSuppliers" style={{marginTop:'60px'}}>

                    <div style={{width: '50%', marginTop:'-150px'}}>
                        <div>
                        <TablePage
                            type="balanceSheet"
                            tableName="SummaryTable"
                            tableRows={this.props.assetsList}
                            tableRow={this.tableRowAssets}
                            searchStrings={this.searchStrings}
                        />
                        </div>
                    </div>

                    <div style={{width: '50%', marginTop: '-150px'}}>
                        <div style={{
                            marginLeft: '-1px',
                        }}>
                            <TablePage
                                type="balanceSheet"
                                tableName="SummaryTable"
                                tableRows={this.props.liabilityAndEquityList}
                                tableRow={this.tableRowLiabilityAndEquity}
                                searchStrings={this.searchStrings}
                            />
                        </div>
                    </div>
                </div>


            </React.Fragment>
        )
    }
}

export default BalanceSheetTable;
